import { ProjectService } from './../project.service';
import { Component, OnInit } from '@angular/core';
import { Project } from '../project';
import { ModalService } from '../modal.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-finished-project',
  templateUrl: './finished-project.component.html',
  styleUrls: ['./finished-project.component.sass']
})
export class FinishedProjectComponent implements OnInit {
  prev: string = "/compose-color-set";
  project: Project;

  constructor(private projectService: ProjectService, private modalService: ModalService, private router: Router) { }

  ngOnInit() {
    this.project = this.projectService.getProject();
  }

  onNextClick(event: string) {
    this.modalService.open('quest-mosaic-dlg');
  }

  closeModal() {
    this.modalService.close('quest-mosaic-dlg');
  }

  accept() {
    this.closeModal();
    this.router.navigate(['/select-mosaic']);
  }

  decline() {
    this.closeModal();
    this.router.navigate(['/what-plaster'])
  }
}
